<template lang="pug">
ul.__parts-nav-hash
  li.item(v-for='item in items', :class='{ selected: item.selected }')
    router-link.link(v-if='!item.to.extUrl', :to='item.to') {{ item.caption }}
    a.link(v-if='item.to.extUrl', :href='item.to.extUrl') {{ item.caption }}
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~@/uikit/stylus/media"

.__parts-nav-hash {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #d3d4d9;
  display: flex;
  align-items: flex-end;
  height: 76px;
  font-size: 16px;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: hidden;

  .item {
    display: inline-block;
    margin-right: 30px;
    font-size: 75%;

    // &:last-child {
    //   margin-right: 0;
    // }

    .link {
      display: inline-block;
      position: relative;
      text-transform: uppercase;
      text-decoration: none;
      color: #59595f;
      line-height: 24px;
      padding: 0;

      &::after {
        opacity: 0;
        position: absolute;
        width: 100%;
        height: 2px;
        top: 100%;
        left: 0;
        content: '';
        background-color: #8163a6;
        transition: all 0.3s ease;
      }

      &.router-link-active {
        font-weight: 800;

        &::after {
          opacity: 1;
        }
      }

      &:hover {
        &::after {
          opacity: 1;
        }
      }
    }
  }

  +tablet() {
    height: 76px;
  }

  +desktop() {
    height: 41px;

    .item {
      .link {
        line-height: 36px;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// Hash.vue?70de8480